// Karta QSL do wydruku lub PDF -- prosto z wpisu w dzienniku. Wyglad z tego
// samego szablonu co karta eQSL (edytor: QSL -> Karta eQSL). Druk w
// rzeczywistym rozmiarze 140 x 90 mm; PDF: A4 z liniami ciecia.
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Icon from './icons';
import { tx } from './i18n';

const API = process.env.REACT_APP_API_URL || '';

async function fetchBlob(url, params) {
  const r = await axios.get(url, { params, responseType: 'blob' });
  return r.data;
}

function saveBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Druk bez nowego okna: ukryta ramka z sama karta w skali 1:1
function printImage(src) {
  const frame = document.createElement('iframe');
  frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0';
  document.body.appendChild(frame);
  const doc = frame.contentWindow.document;
  doc.open();
  doc.write(`<!doctype html><html><head><title>QSL</title><style>@page{size:A4;margin:15mm}html,body{margin:0}
    img{width:140mm;height:auto;display:block}</style></head><body><img src="${src}" alt=""></body></html>`);
  doc.close();
  const img = doc.querySelector('img');
  const go = () => { frame.contentWindow.focus(); frame.contentWindow.print(); setTimeout(() => frame.remove(), 2000); };
  if (img.complete) go(); else img.onload = go;
}

export default function QslCardModal({ qso, onClose, notify, onEditTemplate }) {
  const [lang, setLang] = useState('');
  const [img, setImg] = useState(null);
  const [busy, setBusy] = useState(false);
  const base = `${API}/api/qsl/card/${qso.id}`;
  const fname = `QSL_${String(qso.callsign || '').replace(/[^A-Z0-9]/gi, '_')}`;

  useEffect(() => {
    let url = null;
    let alive = true;
    setImg(null);
    fetchBlob(base, lang ? { lang } : {}).then(b => { if (alive) { url = URL.createObjectURL(b); setImg(url); } })
      .catch(() => { if (alive) notify(tx('Nie udało się wygenerować karty QSL.'), 'error'); });
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [base, lang, notify]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const download = async (format) => {
    setBusy(true);
    try {
      const params = { ...(lang ? { lang } : {}), ...(format === 'pdf' ? { format: 'pdf' } : { download: 1 }) };
      saveBlob(await fetchBlob(base, params), `${fname}.${format}`);
    } catch { notify(tx('Nie udało się pobrać karty.'), 'error'); }
    setBusy(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal qslcard-modal" onClick={e => e.stopPropagation()} role="dialog" aria-label={tx('Karta QSL')}>
        <div className="modal__header">
          <h3><Icon name="printer" size={18} /> {tx('Karta QSL — {0}', [qso.callsign])}</h3>
          <button className="modal__close" onClick={onClose} aria-label={tx('Zamknij')}>✕</button>
        </div>
        <div className="qslcard-preview">
          {img ? <img src={img} alt={tx('Podgląd karty QSL')} /> : <div className="qslcard-preview__loading">{tx('Generuję kartę…')}</div>}
        </div>
        <div className="qslcard-opts">
          <span className="acc-section__hint" style={{ margin: 0 }}>{tx('Język opisów:')}</span>
          <div className="acc-seg" role="group" aria-label={tx('Język opisów:')}>
            {[['', tx('auto')], ['pl', 'PL'], ['en', 'EN']].map(([v, l]) => (
              <button key={v || 'auto'} type="button" className={'acc-seg__btn' + (lang === v ? ' acc-seg__btn--on' : '')}
                aria-pressed={lang === v} onClick={() => setLang(v)}>{l}</button>
            ))}
          </div>
        </div>
        <p className="acc-section__hint">{tx('Druk w rozmiarze karty QSL (140 × 90 mm). PDF: arkusz A4 z liniami cięcia. Wygląd karty zmienisz w edytorze szablonu (ten sam co dla eQSL).')}</p>
        <div className="form-actions">
          <button type="button" className="btn btn--primary" disabled={!img} onClick={() => printImage(img)}>
            <Icon name="printer" size={16} /> {tx('Drukuj')}
          </button>
          <button type="button" className="btn btn--secondary" disabled={busy} onClick={() => download('pdf')}>
            <Icon name="download" size={16} /> PDF
          </button>
          <button type="button" className="btn btn--ghost" disabled={busy} onClick={() => download('png')}>
            <Icon name="image" size={16} /> PNG
          </button>
          <button type="button" className="btn btn--ghost" onClick={() => { onClose(); onEditTemplate?.(); }}>
            <Icon name="edit" size={16} /> {tx('Edytuj szablon')}
          </button>
        </div>
      </div>
    </div>
  );
}

export async function downloadQslCardsPdf(ids, notify) {
  try {
    const r = await axios.post(`${API}/api/qsl/cards.pdf`, { ids }, { responseType: 'blob' });
    saveBlob(r.data, 'QSL_cards.pdf');
  } catch { notify(tx('Nie udało się wygenerować kart QSL.'), 'error'); }
}
